import { Card } from 'antd'
import { FC, memo } from 'react'
import PerButtonCircle from '../ButtonCircle'
import PerFlexRow from '../FlexRow'
import PerText from '../Text'
import './index.less'

type Props = {
  label: string
  date: string
  value: number
}

export const ScoreGridCard: FC<Props> = memo(function ScoreGridCard({ label, date, value }) {
  return (
    <Card bordered={false} className="card">
      <PerText appearance="subheading" display="block" mb="xxxs" align="center" fontSize="s">
        {label}
      </PerText>
      <PerText appearance="label-small" display="block" mb="xs" align="center" fontSize="s">
        {date}
      </PerText>
      <PerText appearance="quote">
        <PerFlexRow justify-content="center" align="middle" direction="column">
          <PerButtonCircle number={value} color="primary" variant="bold" size="small" tabIndex={-1} />
        </PerFlexRow>
      </PerText>
    </Card>
  )
})
